
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/objects/game-center",
      function () {
        return require("private-next-pages/objects/game-center/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/objects/game-center"])
      });
    }
  